var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHighlightLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5252 8.47672C10.9001 7.85182 10.0524 7.50077 9.16856 7.50077C8.28468 7.50077 7.43699 7.85182 6.8119 8.47672L3.47856 11.8101C3.1602 12.1175 2.90626 12.4854 2.73156 12.892C2.55686 13.2987 2.46491 13.7361 2.46106 14.1787C2.45722 14.6213 2.54156 15.0602 2.70916 15.4699C2.87676 15.8796 3.12427 16.2517 3.43725 16.5647C3.75022 16.8777 4.1224 17.1252 4.53205 17.2928C4.94171 17.4604 5.38064 17.5447 5.82324 17.5409C6.26583 17.537 6.70323 17.4451 7.10991 17.2704C7.51659 17.0957 7.88441 16.8418 8.1919 16.5234L9.11023 15.6059M8.47856 11.5234C9.10366 12.1483 9.95135 12.4993 10.8352 12.4993C11.7191 12.4993 12.5668 12.1483 13.1919 11.5234L16.5252 8.19006C17.1324 7.56138 17.4684 6.71937 17.4608 5.84538C17.4532 4.9714 17.1027 4.13535 16.4846 3.51733C15.8666 2.8993 15.0306 2.54874 14.1566 2.54114C13.2826 2.53355 12.4406 2.86953 11.8119 3.47672L10.8952 4.39339",
    stroke: "#0A0A0A",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHighlightLinks);
export default __webpack_public_path__ + "static/media/HighlightLinks.078d14d02f9c476f94961080f265025f.svg";
export { ForwardRef as ReactComponent };